// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const setStatusChangeRequestState = payload => ({
    data: payload,
    type: actions.RESET_STATUS_CHANGE_REQUEST_STATE
});



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/set-status-change-request-state.js